import { render, staticRenderFns } from "./beAnAlternate.vue?vue&type=template&id=10fa85c4&scoped=true"
import script from "./beAnAlternate.vue?vue&type=script&lang=js"
export * from "./beAnAlternate.vue?vue&type=script&lang=js"
import style0 from "./beAnAlternate.vue?vue&type=style&index=0&id=10fa85c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fa85c4",
  null
  
)

export default component.exports